(ns iris.posts.views.post
  (:require
   [re-frame.core :as re-frame]
   [reagent.core :as reagent]
   [goog.html.utils :refer [stripHtmlTags]]
   [clojure.string :as string]
   [goog.string :as gstring]
  ;;  [herb.core :refer [<class <id]]
   [cemerick.url :as cemerick.url]
   [iris.styles.posts :as $posts]
   [iris.globals :as globals]
   [iris.subs :as subs]
   [iris.events :as events]
   [iris.posts.subs :as posts-subs]
   [iris.posts.events :as posts-events]
   [iris.posts.common :refer [route-prefix ruid-to-ahref]]
   [iris.posts.views.post-screening-options :refer [post-screening-options]]
   [iris.common :as common]
   [iris.utils :as utils]
   [iris.components.simple-modal :refer [simple-modal]]
   [iris.posts.views.forms :refer [reply-form op-form]]
   [iris.styles.chips-input :as $chips-input]
   [iris.components.chip :refer [chip]]
   [iris.tags.common :as tags-common]
   [iris.styles.tags :as $tags]
   [iris.tags.subs :as tags-subs]
   [iris.tags.events :as tags-events]
   [iris.error.events :as error-events]
   [goog.functions :as gfn]
   
   [iris.firebase :as firebase]
   [iris.data.api :as data]
   ))






(defn post-timestamp [d]
  [:<>
   [:span.dt-day.text-muted
    {:style {:margin-right "-5px"}}
    (utils/get-day-from-utc-date (:iso_created d) true)]
   [:div {:style {:display "inline-block" :padding "5px 0 0"}}
    [:span
     [:span.text-muted
      {:style {:margin "5px 10px 0px"}}
      [common/copier "copy timestamp" (:iso_created d)]]]]])

(defn post-header [d qp full-id]
  [:header
          ;; NOTE: font-size percent is relative to parent elements font-size
   [:h2.post-title {:style {:font-size "20.79px"}}
          ;;  on thread page display :content :title (including html), on other pages strip html tags and display link to thread
    (if (true? full-id)
      [:a.thread-link
       {:title "Open thread page"
        :href (str route-prefix "/t/" (subs (:thread d) 1))}
       (cond (= (:raw qp) "yes") [:em (get-in d [:content_raw :title])]
             (= (:status d) "S") (get-in d [:content_raw :title])
             :else (stripHtmlTags (or ;; raw fallback
                                   (get-in d [:content :title])
                                   (get-in d [:content_raw :title]))))]
      [:span {:dangerouslySetInnerHTML
              ;; {:__html
              (reagent/unsafe-html
               (cond (= (:raw qp) "yes") (str "<em>" (get-in d [:content_raw :title]) "</em>")
                     (= (:status d) "S") (get-in d [:content_raw :title])
                     :else (or ;; raw fallback
                            (get-in d [:content :title])
                            (get-in d [:content_raw :title]))))
              ;;  }
              }])]])


;; note: this is actually post-reply > post-body
;; post-op does not have <p> around [:content_raw :body]
;; see below
(defn post-body [d qp]
  ;; NOTE: font-size percent is relative to parent elements font-size
  [:div {:style {:font-size "16.8px"}}
   [:div.post-body
    {:dangerouslySetInnerHTML
     ;;  {:__html
     (reagent/unsafe-html
      (cond
        (and (= (:excerpt qp) "yes")
             (= (:raw qp) "yes"))
        (str "<em>" (get-in d [:content_raw :excerpt]) "</em>"
             (when (> (count (get-in d [:content_raw :body])) globals/POSTS_EXCERPT_LIMIT) " [excerpt]"))
        (= (:excerpt qp) "yes")
        (str (get-in d [:content :excerpt]) (when (> (count (get-in d [:content_raw :body])) globals/POSTS_EXCERPT_LIMIT) " [excerpt]"))
        (= (:raw qp) "yes") (str "<p><em>" (get-in d [:content_raw :body]) "</em></p>")
        (= (:status d) "S") (str "<p>" (get-in d [:content_raw :body]) "</p>")
        :else (or ;; raw fallback
               (get-in d [:content :body])
               (get-in d [:content_raw :body]))))
     ;; }
     }]])

;; post-op > post-body
;; [:div {:style {:font-size "16.8px"}}
;;  [:div.post-body
;;   {:dangerouslySetInnerHTML
;;    {:__html
;;     (cond
;;       (and (= (:excerpt qp) "yes")
;;            (= (:raw qp) "yes"))
;;       (str "<em>" (get-in d [:content_raw :excerpt]) "</em>"
;;            (when (> (count (get-in d [:content_raw :body])) globals/POSTS_EXCERPT_LIMIT) " [excerpt]"))
;;       (= (:excerpt qp) "yes")
;;       (str (get-in d [:content :excerpt])
;;            (when (> (count (get-in d [:content_raw :body])) globals/POSTS_EXCERPT_LIMIT) " [excerpt]")) ;; except logic - body has roughly 10 characters extra compared to excerpt (<p></p> etc.) so add that number when comparing the two
;;       (= (:raw qp) "yes") (str "<em>" (get-in d [:content_raw :body]) "</em>")
;;       (= (:status d) "S") (get-in d [:content_raw :body])
;;       :else (or ;; raw fallback
;;              (get-in d [:content :body])
;;              (get-in d [:content_raw :body])))}}]]



;; (defn post-op-footer-mobile []
;;   [:footer.meta
;;    [post-screening-options d roles]
;;    [:div
;;     [:div.signature
;;      [:span.post-timeago
;;       (let [timer @(re-frame/subscribe [::posts-subs/timer])
;;                   ;; date (new js/Date (:iso_published d))
;;                   ;; ms (.getTime date)
;;                   ;; relative (goog.date.relative/format ms)
;;             relative2 (utils/dt2ago (:iso_created d))]
;;         [:time relative2])]
;;      (when-let [author
;;                 (cond (= (:raw qp) "yes") (get-in d [:content_raw :signed])
;;                       (= (:status d) "S") (get-in d [:content_raw :signed])
;;                       :else (or ;; raw fallback
;;                              (get-in d [:content :signed])
;;                              (get-in d [:content_raw :signed])))]
;;        [:<>
;;         " by "
;;         [:span.post-author author]])]
;;     " "
;;     [:div.thread-meta
;;      [post-replies d]
;;      " "
;;      [:div.btn-group.btn-group-xs.approve-remove-buttons
;;       {:role "group"}
;;       [:a.btn.btn-warning
;;        {:on-click (fn [e] (on-click-thread-refresh e (:thread d)))}
;;        [:i.glyphicon.glyphicon-refresh]]]]]
;;    [:div.reactions
;;     [:span.views {:class (<class $posts/counter-red globals/NVIEWS_COUNTER_RED (get-in d [:counts :views]))} (get-in d [:counts :views]) " views"]
;;     [:span.divider " | "]
;;     [post-votes (:id d)]]
;;    [:div.context
;;     "board "
;;     [:span.postid
;;      [:a
;;       {:title (:board_name d)
;;        :href (str route-prefix (:forum d))}
;;       [:code (:forum d)]]]
;;     " "
;;     [:span.cp-id {:style {:position "relative"}}
;;      [:code
;;       [common/copier "copy board ruid" (subs (:forum d) 0 (string/index-of (:forum d) ".")) "📋"]]]
;;     [:div.btn-group.btn-group-xs
;;      [:a.btn
;;       {:title "All posts in this board"
;;        :href (str "/posts?board=" (:forum d))}
;;       [:i.glyphicon.glyphicon-list]]
;;      [:a.btn
;;       {:target "_blank"
;;        :title "Google search executives"
;;        :href (str "https://www.google.com/search?q=" (cemerick.url/url-encode (:board_name d)) "+executives")}
;;       [:i.glyphicon.glyphicon-plane]]]]
;;    [:span.postIdWrap
;;     "post "
;;     [:span.postid
;;      [:code [:a {:href
;;                       ;;  "/p/@OP+1fyWpAs7"
;;                  (str route-prefix (:thread_path d) "#" (subs (:id d)  1 (string/index-of (:id d) (:thread d))))} (:id d)]]]
;;     " "
;;     [:span.cp-id {:style {:position "relative"}}
;;      [:code
;;       [common/copier "copy post ID" (:id d) "📋"]]]]
;;    [screen-notes d]
;;    [moderator-logs index d logs]
;;    [post-filters d qp]]
;;   )

(defn post-signature [d qp]
  [:div.signature
   [:span.post-timeago
    (let [timer @(re-frame/subscribe [::posts-subs/timer])
                  ;; date (new js/Date (:iso_published d))
                  ;; ms (.getTime date)
                  ;; relative (goog.date.relative/format ms)
          relative2 (utils/dt2ago (:iso_created d) false {:months true})]
      [:time relative2])]
   (when-let [author
                      ;;  (if (= (:raw qp) "yes")
                      ;;    (get-in d [:content_raw :signed])
                      ;;    (get-in d [:content :signed]))

              (cond (= (:raw qp) "yes") (get-in d [:content_raw :signed])
                    (= (:status d) "S") (get-in d [:content_raw :signed])
                    :else (or ;; raw fallback
                           (get-in d [:content :signed])
                           (get-in d [:content_raw :signed])))]
     [:<>
      " by "
      [:span.post-author author]])])


(defn- on-click-thread-refresh-replies-btn [e id]
  (.preventDefault e)
  (re-frame/dispatch [::posts-events/http-thread-refresh-replies id]))

(defn post-thread-refresh-replies-btn [d]
  [:div.btn-group.btn-group-xs.approve-remove-buttons
   {:role "group"}
   [:a.btn.btn-warning
    {:title "Refresh replies"
     :on-click (fn [e] (on-click-thread-refresh-replies-btn e (:thread d)))}
    [:i.glyphicon.glyphicon-refresh]]])


;; (defn post-id-wrap [d]
;;   [:span.postIdWrap
;;    "\n\t\t\t\tpost "
;;    [:span.postid
;;     [:code [:a {;; :href (str route-prefix "/p/" (:id d))
;;                 :href (str route-prefix (:thread_path d) "#" (subs (:id d)  1 (string/index-of (:id d) (:thread d))))} (:id d)]]]
;;    " "
;;    [:span.cp-id {:style {:position "relative"}}
;;     [:code
;;      [common/copier "copy post ID" (:id d) "📋"]]]
;;    "\n\t\t\t\t|\n\t\t\t\tthread "
;;    [:span.postid
;;     [:a {:href
;;               ;;  (str route-prefix "/t/" (subs (:thread d) 1))
;;          (str route-prefix (:thread_path d))} [:code (:thread d)]]]
;;    " "
;;    [:span.cp-id {:style {:position "relative"}}
;;     [:code
;;      [common/copier "copy thread ID" (:thread d) "📋"]]]])

(defn post-id [d]
   [:span.postid
    [:code [:a {:href (str route-prefix (:thread_path d) "#" (subs (:id d)  1 (string/index-of (:id d) (:thread d))))} (:id d)]]])

(defn copy-post-id [d]
  [:span.cp-id {:style {:position "relative"}}
   [:code
    [common/copier "copy post ID" (:id d) "📋"]]])

(defn post-thread-id [d]
  [:span.postid
   [:a {:href (str route-prefix (:thread_path d))} [:code (:thread d)]]])

(defn copy-post-thread-id [d]
  [:span.cp-id {:style {:position "relative"}}
   [:code
    [common/copier "copy thread ID" (:thread d) "📋"]]])

(defn post-board-ruid [d]
  [:span.postid
   [:a
    {:title (:board_name d)
     :href (str route-prefix (:forum d))}
    [:code (:forum d)]]])

(defn copy-post-board-ruid [d]
  [:span.cp-id {:style {:position "relative"}}
   [:code
    [common/copier "copy board ruid" (subs (:forum d) 0 (string/index-of (:forum d) ".")) "📋"]]])

(defn post-views [d]
  [:span.views {:class
                ;; (<class $posts/counter-red globals/NVIEWS_COUNTER_RED (get-in d [:counts :views]))
                ($posts/$counter-red globals/NVIEWS_COUNTER_RED (get-in d [:counts :views]))} (get-in d [:counts :views]) " views"])

(defn post-replies [d]
  (let [replies @(re-frame/subscribe [::posts-subs/fb-data :replies (keyword (:id d))])
        replies-n (:n replies)
        replies-t (:t replies)
        replies-msg (if (> replies-n 1)
                      (str replies-n " replies")
                      (if (> replies-n 0)
                        (str replies-n " reply")
                        "no replies"))]
    [:span.reply-counter
     [:span
      (cond (> replies-n 0)
            [:<>
             [:a
              {:href (str route-prefix (:thread_path d) "#replies")
               :class
               ;;  (<class $posts/counter-red globals/NREPLIES_COUNTER_RED replies-n)
               ($posts/$counter-red globals/NREPLIES_COUNTER_RED replies-n)}
              [:strong
               [:span
                replies-msg]]]
             [:span " (last "]
             (let [;;  date (new js/Date (:iso_published d))
              ;;  ms (.getTime date)
              ;;  relative (goog.date.relative/format ms)
                   timer @(re-frame/subscribe [::posts-subs/timer])
                   relative2 (utils/dt2ago (.toISOString (new js/Date (* replies-t 1000))) false {:months true})]
               [:time relative2])
             [:span ")"]]
            :else replies-msg)]]))

(defn post-all-in-board [d]
  [:a.btn
   {:title "All posts in this board"
    :href (str route-prefix "/posts?board=" (:forum d))
    :style {:padding "1px 5px"}}
   [:i.glyphicon.glyphicon-list]])

(defn post-board-execs [d]
  [:a.btn
   {:target "_blank"
    :title "Google search executives"
    :href (str "https://www.google.com/search?q=" (cemerick.url/url-encode (:board_name d)) "+executives")
    :style {:padding "1px 5px"}}
   [:i.glyphicon.glyphicon-plane]])

(defn post-screen-notes [d]
  (when (:screen_notes d)
    [:pre {:title "Screen notes"} (:screen_notes d)]))


;; (defn post-votes [id]
;;   (let [votes @(re-frame/subscribe [::posts-subs/fb-data :votes (keyword id)])]
;;     [:span.vote-reactions-counter
;;      [:span {:class
;;              ;;  (<class $posts/counter-red globals/NVOTES_COUNTER_RED (:t votes))
;;              ($posts/$counter-red globals/NVOTES_COUNTER_RED (:t votes))}
;;       [:span (:t votes)]
;;       " reactions"
;;       [:span " (+" (:u votes)]
;;       "/"
;;       [:span "-" (:d votes)]
;;       ")"]]))



(defn post-votes [d]
  (reagent/with-let [display-form (reagent/atom false)
                     votes-sub (re-frame/subscribe [::posts-subs/fb-data :votes (keyword (:id d))])]
    (let [votes @votes-sub]
      [:<>
       [:span.vote-reactions-counter
        {:style {:cursor "pointer"}
         :on-click (fn [e] (.preventDefault e)
                     (println "click post votes" d)
                     (reset! display-form true))}
        [:span {:class
                ;;  (<class $posts/counter-red globals/NVOTES_COUNTER_RED (:t votes))
                ($posts/$counter-red globals/NVOTES_COUNTER_RED (:t votes))}
         [:span (:t votes)]
         " reactions"
         [:span " (+" (:u votes)]
         "/"
         [:span "-" (:d votes)]
         ")"
         [:code {:style {:padding "0" :margin-left "5px" :font-size "95%"}} "⚙️"]]]
       (when @display-form
         [simple-modal
          "Edit Votes"
          [:div {:class $posts/$edit-votes-form-container}
           [:form {:class $posts/$edit-votes-form}
            [:div {:class $posts/$edit-votes-form-div}
             [:label {:for "up" :class $posts/$edit-votes-form-label} "Up"]
             [:input {:type "number"
                      :name "up"
                      :id "up"
                      :min "0"
                      :step "1"
                      :pattern "\\d*"
                      :inputMode "numeric"
                      :default-value (or (:u votes) 0)
                      :class $posts/$edit-votes-form-input}]]
            [:div {:class $posts/$edit-votes-form-div}
             [:label {:for "down" :class $posts/$edit-votes-form-label} "Down"]
             [:input {:type "number"
                      :name "down"
                      :id "down"
                      :min "0"
                      :step "1"
                      :pattern "\\d*"
                      :inputMode "numeric"
                      :default-value (or (:d votes) 0)
                      :class $posts/$edit-votes-form-input}]]
            [:div {:class $posts/$edit-votes-form-button-container}
             [:button {:type "submit"
                       :class $posts/$edit-votes-form-button
                       :on-click (fn [e]
                                   (.preventDefault e)
                                   (let [up   (.. js/document (querySelector "#up") -valueAsNumber)
                                         down (.. js/document (querySelector "#down") -valueAsNumber)
                                         data {:u up :d down}]
                                     (if (or (js/isNaN up) (js/isNaN down) (< up 0) (< down 0))
                                       (js/alert "Please enter non-negative integers for both fields.")
                                       (-> (data/push-admin-votes-log {:post-ruid (:id d)
                                                                           :forum-ruid (:forum d)
                                                                           :data data})
                                           (.then (fn [_]
                                                    (re-frame/dispatch [::events/add-msg {:info (ruid-to-ahref (str "Votes submitted successfully: " (:id d)))}])
                                                    (let [ws (:ws d)
                                                          forum (:forum (utils/extract-forum-and-website (:forum d)))
                                                          thread (:thread d)
                                                          nick (subs (:id d) 0 (.indexOf (:id d) "+"))]
                                                      (js/setTimeout #(data/get-post-votes ws forum thread nick posts-events/on-update-fb-data-votes) 1000)
                                                      )))
                                           (.catch (fn [err]
                                                     (re-frame/dispatch [::events/add-msg {:error (.-message err)}])))
                                           (.finally (fn []
                                                       (js/console.log "Finished submitting vote")
                                                       (reset! display-form false)))))))}
              "Submit"]]]]
          280
          (fn [e]
            (.preventDefault e)
            (println "edit-votes" d)
            (reset! display-form false))])])))


(defn post-filters [d qp]
  [:div.filters.text-right
   [:div.btn-group.btn-group-xs.ip-buttons
    {:role "group"}
    [:a.btn.btn-default [:i.glyphicon.glyphicon-filter]]
    [:a.btn.btn-default
     {;; :key (str (:id d) (get-in d [:author :eid :cc]) "cc")
      :title "Filter by Country"
      :href
      (str route-prefix "/posts?" (cemerick.url/map->query
                                   ;;  (conj qp {:cc (get-in d [:author :cc])})
                                   (-> qp
                                       (dissoc :bm)
                                       (conj {:cc (get-in d [:author :cc])}))))}
     ":cc"]
    [:a.btn.btn-default
     {;; :key (str (:id d) (get-in d [:author :eid :g_eid]) "g_eid")
      :title "Filter by Geo"
      :href
      (str route-prefix "/posts?" (cemerick.url/map->query
                                   ;;  (conj qp {:geo (get-in d [:author :eid :g_eid])})
                                   (-> qp
                                       (dissoc :bm)
                                       (conj {:geo (get-in d [:author :eid :g_eid])}))))}
     "!geo"]
    [:a.btn.btn-default
     {;; :key (str (:id d) (get-in d [:author :ip]) "ip")
      :title "Filter by IP Address"
      :href
      (str route-prefix "/posts?" (cemerick.url/map->query
                                   ;;  (conj qp {:ip (get-in d [:author :ip])})
                                   (-> qp
                                       (dissoc :bm)
                                       (conj {:ip (get-in d [:author :ip])}))))}
     "^ip"]
    [:a.btn.btn-default
     {;; :key (str (:id d) (get-in d [:author :eid :c_eid]) "c_eid")
      :title "Filter by Cookie"
      :href
      (str route-prefix "/posts?" (cemerick.url/map->query
                                   ;;  (conj qp {:cookie (get-in d [:author :eid :c_eid])})
                                   (-> qp
                                       (dissoc :bm)
                                       (conj {:cookie (get-in d [:author :eid :c_eid])}))))}
     "*ck"]
    [:a.btn.btn-default
     {;; :key (str (:id d) (get-in d [:author :eid :f_eid]) "f_eid")
      :title "Filter by BFP (Browser Fingerprint)"
      :href
      (str route-prefix "/posts?" (cemerick.url/map->query
                                   ;;  (conj qp {:bfp (get-in d [:author :eid :f_eid])})
                                   (-> qp
                                       (dissoc :bm)
                                       (conj {:bfp (get-in d [:author :eid :f_eid])}))))}
     "&bfp"]
    [:a.btn.btn-default
     {;; :key (str (:id d) (get-in d [:author :eid :d_eid]) "d_eid") 
      :title "Filter by DFP (Device Fingerprint)"
      :href
      (str route-prefix "/posts?" (cemerick.url/map->query
                                   ;;  (conj qp {:dfp (get-in d [:author :eid :d_eid])})
                                   (-> qp
                                       (dissoc :bm)
                                       (conj {:dfp (get-in d [:author :eid :d_eid])}))))}
     "~dfp"]
    [:a.btn.btn-default
     {;; :key (str (:id d) (get-in d [:author :eid :a_eid]) "a_eid") 
      :title "Filter by User-Agent"
      :href
      (str route-prefix "/posts?" (cemerick.url/map->query
                                   ;;  (conj qp {:ua (get-in d [:author :eid :a_eid])})
                                   (-> qp
                                       (dissoc :bm)
                                       (conj {:ua (get-in d [:author :eid :a_eid])}))))}
     "%ua"]
    [:a.btn.btn-default
     {;; :key (str (:id d) (get-in d [:author :eid :m_eid]) "m_eid")
      :title "Filter by MIME type"
      :href
      (str route-prefix "/posts?" (cemerick.url/map->query
                                   ;;  (conj qp {:mime (get-in d [:author :eid :m_eid])})
                                   (-> qp
                                       (dissoc :bm)
                                       (conj {:mime (get-in d [:author :eid :m_eid])}))))}
     "m:mime"]
    [:a.btn.btn-default
     {;; :key (str (:id d) (get-in d [:author :eid :l_eid]) "l_eid")
      :title "Filter by Language and Locale"
      :href
      (str route-prefix "/posts?" (cemerick.url/map->query
                                   ;;  (conj qp {:lang (get-in d [:author :eid :l_eid])})
                                   (-> qp
                                       (dissoc :bm)
                                       (conj {:lang (get-in d [:author :eid :l_eid])}))))}
     "l:lang"]
    [:a.btn.btn-default
     {;; :key (str (:id d) (get-in d [:thread]) "thread")
      :title "Filter by Thread"
      :href
      (str route-prefix "/posts?" (cemerick.url/map->query
                                   ;;  (conj qp {:thread (subs (get-in d [:thread]) 1)})
                                   (-> qp
                                       (dissoc :bm)
                                       (conj {:thread (subs (get-in d [:thread]) 1)}))))}
     "+thread"]


    (when (true? (get-in d [:author :staff]))
      [:a.btn.btn-default
       {:title "Filter by User"
        :href
        (str route-prefix "/posts?" (cemerick.url/map->query
                                     (-> qp
                                         (dissoc :bm)
                                         (conj {:user (get-in d [:author :uid])}))))}
       "=usr"])


    [:a.btn.btn-default
     {;; :key (str (:id d) (get-in d [:forum]) "forum")
      :title "Filter by Board"
      :href
      (str route-prefix "/posts?" (cemerick.url/map->query
                                   ;;  (conj qp {:board (get-in d [:forum])})
                                   (-> qp
                                       (dissoc :bm)
                                       (conj {:board (get-in d [:forum])}))))}
     "/board"]



    [:a.btn.btn-default
     {;; :key (str (:id d) (get-in d [:forum]) "forum")
      :title "Filter by Cookie + BFP + DFP + Board"
      :href
      (str route-prefix "/posts?" (cemerick.url/map->query
                                   (-> qp
                                       (dissoc :bm)
                                       (conj {:cookie (get-in d [:author :eid :c_eid])
                                              :bfp    (get-in d [:author :eid :f_eid])
                                              :dfp    (get-in d [:author :eid :d_eid])
                                              :board  (get-in d [:forum])}))

                                   ;;  checks for values being present
                                   ;;  (cond-> (dissoc qp :bm)
                                   ;;    (seq (get-in d [:author :eid :c_eid]))
                                   ;;    (conj {:cookie (get-in d [:author :eid :c_eid])})

                                   ;;    (seq (get-in d [:author :eid :f_eid]))
                                   ;;    (conj {:bfp (get-in d [:author :eid :f_eid])})

                                   ;;    (seq (get-in d [:author :eid :d_eid]))
                                   ;;    (conj {:dfp (get-in d [:author :eid :d_eid])})

                                   ;;    (seq (get-in d [:forum]))
                                   ;;    (conj {:board (get-in d [:forum])}))
                                   ))}
     "*&~/"]]])


;; (defn post-mod-logs-border-style [logs batch-datetime]
;;   (when (> (count logs) 0)
;;     (let [mod-logs-desc (sort-by
;;                         ;;  :datetime
;;                          :ms
;;                          #(compare %2 %1) logs)
;;           mod-logs-latest (first mod-logs-desc)]
;;     ;; (cond (= (:status mod-logs-latest) "R")
;;     ;;       {:border "2px solid #d9534f" :border-radius "5px"}
;;     ;;       (= (:status mod-logs-latest) "P")
;;     ;;       {:border "2px solid #5cb85c" :border-radius "5px"})
;;       ;; (println "TIMEDIFF::" (- (.now js/Date) (:datetime mod-logs-latest)))
;;       (cond (and (= (:uid mod-logs-latest) (:uid @globals/fbjwt-payload))
;;                 ;;  (>= (:datetime mod-logs-latest) batch-datetime)
;;                  (>= (:ms mod-logs-latest) batch-datetime))
;;             {:border "2px solid rgb(102,157,246)" :border-radius "5px"}
;;             (and (not= (:uid mod-logs-latest) (:uid @globals/fbjwt-payload))
;;                 ;;  (< (/ (- (.now js/Date) (:datetime mod-logs-latest)) 1000) 300)
;;                 ;;  (>= (:datetime mod-logs-latest) batch-datetime)
;;                  (>= (:ms mod-logs-latest) batch-datetime))
;;             {:border "2px solid orange" :border-radius "5px"}
;;             ;; (not= (:uid mod-logs-latest) (:uid @globals/fbjwt-payload))
;;             ;; {:border "2px solid slategrey" :border-radius "5px"}
;;             ))))


(defn post-mod-logs-border-style [logs batch-datetime]
  (when (> (count logs) 0)
    (let [mod-logs-desc (sort-by
                         ;;  :datetime
                         :ms
                         #(compare %2 %1) logs)
          mod-logs-latest (first mod-logs-desc)]

      (cond (and (= (:uid mod-logs-latest) (:uid @globals/fbjwt-payload))
                 (>= (:ms mod-logs-latest) batch-datetime))
            {:post-mod-by-me true}
            (and (not= (:uid mod-logs-latest) (:uid @globals/fbjwt-payload))
                 (>= (:ms mod-logs-latest) batch-datetime))
            {:post-mod-by-others true}
            ))))

(defn- post-moderator-logs-ul-li [l]
  (let [timer @(re-frame/subscribe [::posts-subs/timer])
        relative2 (utils/dt2ago (.toISOString (new js/Date
                                                  ;;  (:datetime l)
                                                   (:ms l))))]
    ;; (cond (contains? l :status)
    ;;       [:li {:key (str "log" (:datetime l))} "Status set to " [:strong {:class (moderator-bar/status-color (:status l))} (:status l)] " by " [:a {:href (str "/user/" (:uid l))} (:uid l)] " " relative2]
    ;;       (contains? l :replying_disabled)
    ;;       [:li {:key (str "log" (:datetime l))} (if (true? (:replying_disabled l)) "Replying Disabled" "Replying Enabled") " by " [:a {:href (str "/user/" (:uid l))} (:uid l)] " " relative2]
    ;;       (contains? l :hidden)
    ;;       [:li {:key (str "log" (:datetime l))} "Hidden set to " (str (:hidden l)) " by " [:a {:href (str "/user/" (:uid l))} (:uid l)] " " relative2])
    [:li  (str (:action l)) " by " [:a {:href (str "/user/" (:uid l))} (:uid l)] " " relative2]))

(defn post-moderator-logs [index d logs]
  (reagent/with-let [show-logs (reagent/atom false)]
    (when (> (count logs) 0)
      (let [logs-desc (sort-by
                    ;;  :datetime
                       :ms
                       #(compare %2 %1) logs)
          ;; show (reagent/atom false)
            ]
      ;; (println "show:" @show)
        [:<>
         [:pre {:title "Moderator Logs"}
          [:ul {:class
                ;; (<class $posts/all-moderator-logs-ul)
                $posts/$all-moderator-logs-ul}
           (for [l (take 2 logs-desc)]
             ^{:key (str (gensym "log-") (:ms l))} [post-moderator-logs-ul-li l])

           ;;  (when (true? @show)
           ;;    (for [l (nthrest logs-desc 2)]
           ;;      [post-moderator-logs-ul-li l]))
           (when (true?
                  ;; (:show-logs d)
                  (true? @show-logs))
             (for [l (nthrest logs-desc 2)]
               ^{:key (str (gensym "log-") (:ms l))} [post-moderator-logs-ul-li l]))

           ;;  (when (> (count logs) 2)
           ;;    [:li {:class (<class $posts/all-moderator-logs-more-btn)}
           ;;     [:a {:on-click (fn [e]
           ;;                      (.preventDefault e)
           ;;                      (reset! show (not @show)))}
           ;;      (if (true? @show) "less" "more")]])

           (when (> (count logs) 2)
             [:li {:class
                   ;;  (<class $posts/all-moderator-logs-more-btn)
                   $posts/$all-moderator-logs-more-btn}
              [:a {:on-click (fn [e]
                               (.preventDefault e)
                               ;;  (reset! show (not @show))
                               ;;  (re-frame/dispatch [::posts-events/set-posts-data-row-prop index :show-logs (not (:show-logs d))])
                               (reset! show-logs (not @show-logs)))}
               (if (true?
                    ;; @show
                    ;; (:show-logs d)
                    (true? @show-logs)) "less" "more")]])]]]))))


;; (defn post-footer-thread-meta [d]
;;   [:div.thread-meta
;;    [:span.divider  " | "]
;;    [post-views d]
;;    [:span.divider " | "]
;;    [post-votes (:id d)]
;;    [:span.divider " | "]
;;    [post-replies d]
;;    " "
;;    [post-thread-refresh-replies-btn d]])


;; (defn post-footer-reply-meta [d]
;;   [:div.reply-meta
;;    [:span.divider " | "]
;;    [post-votes (:id d)]])




(defn dm-write [d]
  (reagent/with-let [display-form (reagent/atom false)
                     display-options (reagent/atom false)
                     form (reagent/atom "reply")]
    [:div.btn-group.btn-group-xs {:on-mouse-over (fn [e]
                                                   (.preventDefault e)
                                                   (reset! display-options true))
                                  :on-mouse-out (fn [e]
                                                  (.preventDefault e)
                                                  (reset! display-options false))
                                  :style {:display "inline-block"}}
     [:button {:title "Reply or Promote post"
               :class "btn btn-success"
               :style {:cursor "pointer"
                       :position "relative"}
               :on-click (fn [e]
                           (.preventDefault e)
                           (reset! display-options true))}
      [:i {:class "glyphicon glyphicon-pencil"}]]
     (when @display-options
       [:div {:class "btn-group btn-group-xs"
              :role "group"
              :style {:display "inline-block"
                      :border-radius "auto"}}
        [:button {:class "btn btn-default"
                  :on-click (fn [e]
                              (.preventDefault e)
                              (reset! form "reply")
                              (reset! display-form (not @display-form)))} "reply"]
        [:button {:class "btn btn-default"
                  :on-click (fn [e]
                              (.preventDefault e)
                              (reset! form "promo")
                              (reset! display-form (not @display-form)))} "promo"]])
     (when @display-form
       [simple-modal
        (cond (= @form "reply")
              "Reply to post"
              (= @form "promo")
              "Promo post to OP")
        (cond (= @form "reply")
              [reply-form d {:dm true
                             :on-success #(reset! display-form false)}]
              (= @form "promo")
              [op-form d {:dm true
                          :on-success #(reset! display-form false)}])
        400
        (fn [e]
          (.preventDefault e)
          (reset! display-form false)
          (reset! display-options false))])]))







(defn post-op-footer-meta-desktop [d qp]
;;   1 hour ago by Anonymous | 8 views | 1 reaction (+0/-1) | no replies yet
;;   post @OP+1rClj30i 📋 | thread +1rClj30i 📋 | board /t-mobile-us.TLO 📋
  [:div {:style {:margin "5px 0"}}
   [:div
    [post-signature d qp] " | " [post-views d] " | " [post-votes d] " | " [post-replies d] " " [post-thread-refresh-replies-btn d] (when (= (:status d) "P") [:<> " " [dm-write d]])]
   [:div "post " [post-id d] [copy-post-id d] " | thread " [post-thread-id d] [copy-post-thread-id d] " | board " [post-board-ruid d] [copy-post-board-ruid d] [post-all-in-board d] [post-board-execs d]]])

(defn post-op-footer-meta-mobile [d qp]
  [:div {:style {:margin "5px 0"}}
   [:div [post-signature d qp]]
   [:div [post-replies d] " " [post-thread-refresh-replies-btn d] (when (= (:status d) "P") [:<> " " [dm-write d]])]
   [:div [post-views d] " | " [post-votes d]]
   [:div "board " [post-board-ruid d] [copy-post-board-ruid d] [post-all-in-board d] [post-board-execs d]]
   [:div "post " [post-id d] [copy-post-id d]]])

(defn post-reply-footer-meta-desktop [d qp]
;;   15 minutes ago by abc | 1 reaction (+1/-0)
;;   post @hth+1rCa9MCC 📋 | thread +1rCa9MCC 📋 | board /transunion.TLO 📋
  [:div {:style {:margin "5px 0"}}
   [:div
    [post-signature d qp] " | " [post-votes d] (when (= (:status d) "P") [:<> " | " [dm-write d]])]
   [:div "post " [post-id d] [copy-post-id d] " | thread " [post-thread-id d] [copy-post-thread-id d] " | board " [post-board-ruid d] [copy-post-board-ruid d] [post-all-in-board d] [post-board-execs d]]])

(defn post-reply-footer-meta-mobile [d qp]
  [:div {:style {:margin "5px 0"}}
   [:div [post-signature d qp]]
   [:div [post-votes d] (when (= (:status d) "P") [:<> " | " [dm-write d]])]
   [:div "thread " [post-thread-id d] [copy-post-thread-id d] " | "  (gstring/unescapeEntities "&nbsp;") "board " [post-board-ruid d] [copy-post-board-ruid d] [post-all-in-board d] [post-board-execs d]]
   [:div "post " [post-id d] [copy-post-id d]]])



;; (defn post-footer-desktop [index d qp roles logs]
;;   [:footer.meta
;;    [post-screening-options d roles]
;; ;;    [:div
;; ;;     [post-signature d qp]
;; ;;     ;; " "
;; ;;     ;; (cond
;; ;;     ;;   (= (:level d) 1)
;; ;;     ;;   [post-footer-thread-meta d]
;; ;;     ;;   (= (:level d) 2)
;; ;;     ;;   [post-footer-reply-meta d])
;; ;;     ]
;; ;;    [:span.postIdWrap
;; ;;     "post "
;; ;;     [post-id d]
;; ;;     " "
;; ;;     [copy-post-id d]
;; ;;     " | thread "
;; ;;     [post-thread-id d]
;; ;;     " "
;; ;;     [copy-post-thread-id d]]
;; ;;    [:div.context
;; ;;     " | board "
;; ;;     [post-board-ruid d]
;; ;;     " "
;; ;;     [copy-post-board-ruid d]
;; ;;     [:div.btn-group.btn-group-xs
;; ;;      [post-all-in-board d]
;; ;;      [post-board-execs d]]]
;; ;;    [reply-desktop d qp]
;;    [post-screen-notes d]
;;    [post-moderator-logs index d logs]
;;    [post-filters d qp]])


;; (defmulti post-footer-meta
;;   (fn [d qp]
;;     (cond (= (:level d) 1)
;;           :op
;;           (= (:level d) 2)
;;           :reply)))

;; (defmethod post-footer-meta :op [d qp])


;; (defn post-footer-mobile [index d qp roles logs]
;;   [:footer.meta
;;    [post-screening-options d roles]
;;    [:div
;;     [post-signature d qp]
;;     " "
;;     (when (= (:level d) 1)
;;       [:div.thread-meta
;;        [post-replies d]
;;        " "
;;        [post-thread-refresh-replies-btn d]])]
;;    [:div.reactions
;;     (when (= (:level d) 1)
;;       [:<>
;;        [post-views d]
;;        [:span.divider " | "]])
;;     [post-votes (:id d)]]
;;    [:div.context
;;     (when (= (:level d) 2)
;;       [:<>
;;        "thread "
;;        [post-thread-id d]
;;        " "
;;        [copy-post-thread-id d]])
;;     "board "
;;     [post-board-ruid d]
;;     " "
;;     [copy-post-board-ruid d]
;;     [:div.btn-group.btn-group-xs
;;      [post-all-in-board d]
;;      [post-board-execs d]]]
;;    [:span.postIdWrap
;;     "post "
;;     [post-id d]
;;     " "
;;     [copy-post-id d]]
;;    [post-screen-notes d]
;;    [post-moderator-logs index d logs]
;;    [post-filters d qp]])


;; (defn post-footer [index d qp roles logs]
;;   (let [viewport-size @(re-frame/subscribe [::subs/viewport-size])]
;;     (println "(:x viewport-size):" (:x viewport-size))
;;     (if (>= (:x viewport-size) 768)
;;       [post-footer-desktop index d qp roles logs]
;;       [post-footer-mobile index d qp roles logs])))

(defn post-footer [index d qp roles logs]
  (let [viewport-size @(re-frame/subscribe [::subs/viewport-size])]
    [:footer.meta
     [post-screening-options d roles]
     (cond
       (= (:level d) 1)
       (if (>= (:x viewport-size) 768)
         [post-op-footer-meta-desktop d qp]
         [post-op-footer-meta-mobile d qp])
       (= (:level d) 2)
       (if (>= (:x viewport-size) 768)
         [post-reply-footer-meta-desktop d qp]
         [post-reply-footer-meta-mobile d qp]))
     [post-screen-notes d]
     [post-moderator-logs index d logs]
     [post-filters d qp]]))


(defn- unset-post-ref-preview [paruid k]
  (re-frame/dispatch [::posts-events/unset-post-ref-preview-data paruid k]))

(defn post-ref-preview [paruid refs batch-datetime]
  [:div
   (for [[k v] refs]
     (when (>= (:dt v) batch-datetime)
       [:div.panel.panel-default
        {:style {:margin "10px"
                 :border-color "#FFE5B4"}}
        [:div.panel-heading {:style {:padding "5px 10px"
                                     :background-color "rgb(252, 248, 227)"
                                     :border-color "#FFE5B4"}}
         [:span k]
         [:button {:type "button"
                   :class "close"
                   :title "close"
                   :on-click (fn [e] (unset-post-ref-preview paruid k))}
          [:span "×"]]]
        [:div.post-body.panel-body
         {:style {:padding "5px 10px"
                  :text-decoration-line "none"}}
         (when (= (:level v) 1)
           [:h4 (or (get-in v [:content :title]) "")])
         [:div
          {:dangerouslySetInnerHTML
           ;;  {:__html
           (reagent/unsafe-html
            (string/replace (get-in v [:content :body]) #"<a[^>]*>([^<]+)</a>" (str "$1")))
           ;; }
           }]
         [:div {:style {:margin "5px 0" :border-top "1px solid #ddd"}}]
         [:span {:style {:float "left"}} (utils/dt2ago (:iso_created v)) " by " (get-in v [:content :signed])]
         [:span {:title (str "Status: " (:status v))
                 ;;  :style {:float "right"
                 ;;          :font-weight "bold"
                 ;;          :color "#666"}
                 :class
                 ;;  (<class $posts/post-ref-status)
                 $posts/$post-ref-status} (:status v)]
         [:a {:href ""
              :title "reload"
              :style {:float "right"
                      :margin "0 10px"} :on-click (fn[e] (posts-events/fetch-cache-set-post-ref-preview-data paruid k))} [:i {:class (str "glyphicon glyphicon-refresh" " "
                                                                                                                                          ;; (<class $posts/post-ref-refresh)
                                                                                                                                          $posts/$post-ref-refresh)
                                                                                                                              ;; :style {:font-size "12px"
                                                                                                                              ;;         :color "#999"}
                                                                                                                              }]]
         ]]))])